type StatCardProps = {
  title: string;
  value: string | number;
  hint?: string;
  /** Carte solde / KPI principal : gradient nuit–rose (une seule par zone KPI recommandée) */
  accent?: boolean;
  /** Cellule dans une grille `gap-px bg-[#e4e8ef]` (pas de bordure par cellule) */
  inGrid?: boolean;
};

export default function StatCard({ title, value, hint, accent, inGrid }: StatCardProps) {
  const labelCls = accent
    ? "text-[10px] font-semibold uppercase tracking-[0.08em] text-white/55 mb-3"
    : "text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-400 mb-3";
  const valueCls = accent
    ? "font-mono text-xl font-medium text-white tracking-tight mb-2"
    : "font-mono text-xl font-medium text-[#1a2744] tracking-tight mb-2";
  const hintCls = accent
    ? "text-[11px] text-white/35"
    : "text-[11px] text-slate-400";

  if (inGrid) {
    return (
      <div
        className={`p-4 md:p-5 ${accent ? "text-white" : "bg-white"}`}
        style={accent ? { background: "linear-gradient(135deg, #1a2744 0%, #b03a6e 100%)" } : undefined}
      >
        <p className={labelCls}>{title}</p>
        <p className={valueCls}>{value}</p>
        {hint ? <p className={hintCls}>{hint}</p> : null}
      </div>
    );
  }

  if (accent) {
    return (
      <div
        className="rounded-lg p-4 md:p-5 text-white"
        style={{ background: "linear-gradient(135deg, #1a2744 0%, #b03a6e 100%)" }}
      >
        <p className={labelCls}>{title}</p>
        <p className={valueCls}>{value}</p>
        {hint ? <p className={hintCls}>{hint}</p> : null}
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-[#e4e8ef] bg-white p-4 md:p-5">
      <p className={labelCls}>{title}</p>
      <p className={valueCls}>{value}</p>
      {hint ? <p className={hintCls}>{hint}</p> : null}
    </div>
  );
}
